import React, { useState } from "react";
import FacebookIcon from "../../assets/icons/FacebookIcon";
import XIcon from "../../assets/icons/XIcon";
import InstagramIcon from "../../assets/icons/InstagramIcon";
import YouTubeIcon from "../../assets/icons/YoutubeIcon";
import TelegramIcon from "../../assets/icons/TelegramIcon";
import "./ContactPage.css";

const contactInfo = {
  phone: "+91 8902955624",
  email: "info@zynventics.com",
  address:
    "Near Youniform World, Gobardanga station road, Ramnagar North 24 Parganas – 743273, West Bengal, India",
};

const mapAddressQuery =
  "Near+Youniform+World,+Gobardanga+Station+Road,+Ramnagar,+Gobardanga,+West+Bengal+-+743273,+India";

const socialLinks = [
  { href: "https://facebook.com", label: "Facebook", Icon: FacebookIcon },
  { href: "https://x.com", label: "X", Icon: XIcon },
  { href: "https://instagram.com", label: "Instagram", Icon: InstagramIcon },
  { href: "https://youtube.com", label: "YouTube", Icon: YouTubeIcon },
  { href: "https://telegram.org", label: "Telegram", Icon: TelegramIcon },
];

const web3forms = process.env.REACT_APP_WEB3_FORM_KEY;
/* ── small inline SVG icons ── */
const PhoneIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07
      A19.5 19.5 0 013.07 10.8a19.79 19.79 0 01-3.07-8.69A2 2 0 012 0h3
      a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09
      7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573
      2.81.7A2 2 0 0122 14.92z"
    />
  </svg>
);

const MailIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1
      0-2-.9-2-2V6c0-1.1.9-2 2-2z"
    />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const PinIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const ClockIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const SendIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="18"
    height="18"
  >
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);

/* ─────────────────────────────────────────────
   CONTACT PAGE &   Form Submitter
───────────────────────────────────────────── */
const ContactPage = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("access_key", web3forms);
      console.log("Web3forms Key:", web3forms); // Debug: Check if the key is loaded correctly

      // Append your form fields
      formData.append("name", form.name);
      formData.append("email", form.email);
      formData.append("subject", form.subject);
      formData.append("message", form.message);

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setSent(true);
        setTimeout(() => setSent(false), 4000);
        setForm({ name: "", email: "", subject: "", message: "" });
      } else {
        console.log("Error:", data);
      }
    } catch (error) {
      console.log("Submission failed:", error);
    }
  };

  return (
    <div className="cp-root page-section section-reveal visible">
      {/* ── HERO BAND ── */}
      <section className="cp-hero">
        <div className="cp-hero__badge">Get in Touch</div>
        <h1 className="cp-hero__title">
          We'd Love to <span className="cp-hero__accent">Hear From You</span>
        </h1>
        <p className="cp-hero__sub">
          Sales, support, or just a question — our team is ready within one
          business day.
        </p>
      </section>

      {/* ── QUICK FACTS STRIP ── */}
      <section className="cp-facts">
        <div className="cp-fact">
          <span className="cp-fact__icon">
            <ClockIcon />
          </span>
          <div>
            <strong>Mon – Sat</strong>
            <span>10 AM – 6 PM IST</span>
          </div>
        </div>
        <div className="cp-fact cp-fact--mid">
          <span className="cp-fact__icon">
            <PhoneIcon />
          </span>
          <div>
            <strong>Call Us</strong>
            <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
          </div>
        </div>
        <div className="cp-fact">
          <span className="cp-fact__icon">
            <MailIcon />
          </span>
          <div>
            <strong>Email Us</strong>
            <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
          </div>
        </div>
      </section>

      {/* ── MAIN GRID: FORM + SIDEBAR ── */}
      <section className="cp-main">
        {/* LEFT — Contact Form */}
        <div className="cp-form-panel">
          <div className="cp-form-panel__header">
            <h2>Send a Message</h2>
            <p>Fill in the form and we'll get back to you shortly.</p>
          </div>

          <form className="cp-form" onSubmit={handleSubmit} noValidate>
            <div className="cp-form__row">
              <div className="cp-form__field">
                <label htmlFor="name">Full Name</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="e.g. Rahul Sharma"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="cp-form__field">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="you@example.com"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="cp-form__field">
              <label htmlFor="subject">Subject</label>
              <input
                id="subject"
                name="subject"
                type="text"
                placeholder="What's this about?"
                value={form.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div className="cp-form__field">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                rows={5}
                placeholder="Tell us how we can help…"
                value={form.message}
                onChange={handleChange}
                required
              />
            </div>

            <button
              type="submit"
              className={`cp-submit${sent ? " cp-submit--sent" : ""}`}
            >
              {sent ? (
                "Message Sent!"
              ) : (
                <>
                  <SendIcon /> Send Message
                </>
              )}
            </button>
          </form>
        </div>

        {/* RIGHT — Info Sidebar */}
        <aside className="cp-sidebar">
          <div className="cp-info-card">
            <span className="cp-info-card__icon">
              <PhoneIcon />
            </span>
            <div className="cp-info-card__body">
              <h3>Call Us</h3>
              <p>Mon – Sat &nbsp;|&nbsp; 10 AM – 6 PM</p>
              <a
                href={`tel:${contactInfo.phone}`}
                className="cp-info-card__link"
              >
                {contactInfo.phone}
              </a>
            </div>
          </div>

          <div className="cp-info-card">
            <span className="cp-info-card__icon">
              <MailIcon />
            </span>
            <div className="cp-info-card__body">
              <h3>Email</h3>
              <p>We reply within 24 hours</p>
              <a
                href={`mailto:${contactInfo.email}`}
                className="cp-info-card__link"
              >
                {contactInfo.email}
              </a>
            </div>
          </div>

          <div className="cp-info-card">
            <span className="cp-info-card__icon">
              <PinIcon />
            </span>
            <div className="cp-info-card__body">
              <h3>Visit Us</h3>
              <p>{contactInfo.address}</p>
            </div>
          </div>

          {/* Social */}
          <div className="cp-social">
            <p className="cp-social__label">Follow Zynvert</p>
            <div className="cp-social__icons">
              {socialLinks.map(({ href, label, Icon }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  className="cp-social__btn"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>
        </aside>
      </section>

      {/* ── MAP ── */}
      <section className="cp-map">
        <div className="cp-map__label">
          <PinIcon />
          <span>Our Location — Kolkata, West Bengal</span>
        </div>
        <div className="cp-map__frame">
          <iframe
            src={`https://maps.google.com/maps?q=${mapAddressQuery}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Zynventics Technologies Location"
          />
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
